export const stats = [
  {
    statTitle: 'Connected Nodes',
    statNum: 735,
    statCap: 'M'
  },
  {
    statTitle: 'Storage Capacity',
    statNum: 1.22,
    statCap: 'Exabyte (EB)'
  },
  {
    statTitle: 'Stored Data ',
    statNum: 1.34,
    statCap: 'Petabyte (PB) '
  },
  {
    statTitle: 'Created Pools',
    statNum: 456,
    statCap: 'M'
  }
]

export const features = [
  [
    {
      title: 'connect_to_decentralized_storage_title',
      text: 'connect_to_decentralized_storage_text'
    },
    {
      title: 'cost_title',
      text: 'cost_text'
    }
  ],
  { middleIcon: 'middleIcon' },
  [
    {
      title: 'global_storage_connection_title',
      text: 'global_storage_connection_text'
    },
    {
      title: 'security_title',
      text: 'security_text'
    }
  ]
]

export const items = [
  {
    image: 'demoCardPhoto',
    title: 'Lorem ipsum dolor sit amet',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit commodo sapien sit amet interdum. Integer vestibulum dolor semper, fringilla magna nec, egestas nisl. Etiam ullamcorper neque nec ligula pellentesque, vel feugiat augue egestas.'
  },
  {
    image: 'demoCardPhoto',
    title: 'Lorem ipsum dolor sit amet',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit commodo sapien sit amet interdum. Integer vestibulum dolor semper, fringilla magna nec, egestas nisl. Etiam ullamcorper neque nec ligula pellentesque, vel feugiat augue egestas.'
  },
  {
    image: 'demoCardPhoto',
    title: 'Lorem ipsum dolor sit amet',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit commodo sapien sit amet interdum. Integer vestibulum dolor semper, fringilla magna nec, egestas nisl. Etiam ullamcorper neque nec ligula pellentesque, vel feugiat augue egestas.'
  },
  {
    image: 'demoCardPhoto',
    title: 'Lorem ipsum dolor sit amet',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit commodo sapien sit amet interdum. Integer vestibulum dolor semper, fringilla magna nec, egestas nisl. Etiam ullamcorper neque nec ligula pellentesque, vel feugiat augue egestas.'
  }
]
